let configuration;

export function siteConfig() {
    if (!configuration) {
        try { configuration = JSON.parse((typeof document === 'undefined' ? null : document.getElementById('nova-site-config'))?.textContent || '{}'); }
        catch { configuration = {}; }
    }
    return configuration;
}

export function copy(text) {
    return siteConfig().copy?.[text] ?? text;
}

export function assetUrl(path) {
    const value = String(path ?? '').trim();
    return !value || /^(?:[a-z][a-z0-9+.-]*:|\/\/|\/)/i.test(value) ? value : `/${value}`;
}
